module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"unableToFindEdiLog":"Unable to find outbound EDI for stretch","ediHasBeenSentTo":"EDI sent to: ","ediHasBeenSentDate":"Date: "},"no":{"unableToFindEdiLog":"Fant ikke utgående EDI for gjeldende strekning","ediHasBeenSentTo":"EDI sendt til ","ediHasBeenSentDate":"Dato: ","ediHasBeenSentWithPartAndDate":"EDI sendt til {0}: {1}"}}')
  delete Component.options._Ctor
}
